import { scan } from "@pdfking/rfunc"

const data: Record<string, unknown> = {}

export const settings_get = (...args: string[]) => {
  const result = args.reduce((s, k) => (s ? s[k] : s), data)
  return result
}

export const settings_set = (key: string, value: Record<string, unknown>) => {
  data[key] = data[key] || {}
  scan((v, k) => (data[key][k] = v), value)
}

export const settings_extend = (key: string, value: unknown[]) => {
  data[key] = data[key] || []
  scan(v => (data[key] as unknown[]).push(v), value)
}
